import { render } from "./WidgetPart.vue?vue&type=template&id=56a3627e"
import script from "./WidgetPart.vue?vue&type=script&lang=js"
export * from "./WidgetPart.vue?vue&type=script&lang=js"

import "./WidgetPart.vue?vue&type=style&index=0&id=56a3627e&lang=css"

import exportComponent from "/home/jstechno-26/projects/Barting-Coin/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__